module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "tiph"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("TIPS FOR STAYING ORGANIZED")])])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('hr', {
    staticClass: "hr"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindentlb"
  }, [_vm._v("When you can’t find something you need or aren’t sure where to begin and what to prioritize, you can’t possibly be productive. Keeping even a little bit of organization in your life will go a long way toward your success. Here are some easy ways to stay organized:")]), _vm._v(" "), _c('p', {
    staticClass: "number1"
  }, [_vm._v("39. Don’t let things pile up. If you’re putting off tasks, find a way to either tackle them ASAP or pass them along to someone else who can.")]), _vm._v(" "), _c('p', {
    staticClass: "number1"
  }, [_vm._v("40. File paperwork as soon as you can. The more you let things accumulate on your desk, the harder it will be to get organized (or find certain papers) later on.")]), _vm._v(" "), _c('p', {
    staticClass: "number1"
  }, [_vm._v("41. Keep a donation box tucked away in a closet at home where you and other family members can drop things that you know you no longer need.")]), _vm._v(" "), _c('p', {
    staticClass: "number1"
  }, [_vm._v("42. Clean out your fridge weekly to make sure you don’t have expired food hanging around. You don’t want to plan on a breakfast with that bottle of OJ, only to discover it expired last month!")]), _vm._v(" "), _c('p', {
    staticClass: "number1"
  }, [_vm._v("43. Before your kids go to bed at night, hold a “race” to see who can pick up and put away the most out-of-place stuff (e.g., toys and stray shoes) the fastest.")])]), _c('p', {
    staticClass: "number1"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("44. ")]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Organize your closet by occasion rather than item. When all your formal wear is together, it will be easier to find something for that big night out.")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "number1"
  }, [_vm._v("45. If something is broken and you don’t have immediate plans to fix it, get rid of it. Don’t keep things because you might repair them “one day.”")]), _vm._v(" "), _c('p', {
    staticClass: "number1"
  }, [_vm._v("46. If you have a lot to organize, start small, like organizing one desk drawer at a time. By the end of the week you will have an organized desk and will be ready to tackle that bookshelf.")]), _vm._v(" "), _c('p', {
    staticClass: "number1"
  }, [_vm._v("47. Store things you use ten times a year or less in long-term storage like a garage or remote closet. Don’t give those items prime real estate in your home!")]), _vm._v(" "), _c('p', {
    staticClass: "number1"
  }, [_vm._v("48. Use hanging shoe organizers that go over the back of doors to organize office supplies, cables, and more.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4781a410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01d.vue
// module id = 84
// module chunks = 0